// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__1YSl3","nav":"header_nav__1jJyY","logo":"header_logo__1Rwh4","ulMain":"header_ulMain__2LuG1","homeIcon":"header_homeIcon__2NCGG"};